/**************************************************
 * Nombre:       PropuestaValor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, AvatarGroup, Button, Grid, Typography} from "@mui/material";
import {GRADIENTE, URLUSUARIO} from "../../../../Constantes";
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {contarColeccion} from "../../../../Servicios/BD/Contadores/contarColeccion";
import {collection, limit, orderBy, query} from "firebase/firestore";
import {fire} from "../../../../fire";
import {obtenerColeccionQuery} from "../../../../Servicios/BD/obtenerColeccionQuery";
import {irUrl} from "../../../../Utilidades/irUrl";

const PropuestaValor = () => {
    const {sCell, masSM} = useResponsive()
    const [numCuentas, setNumCuentas] = useState(0);
    const [cuentas, setCuentas] = useState([]);

    useEffect(() => {

        contarColeccion({coleccion: 'cuentas'}).then((dox) => {
            setNumCuentas(dox.data)
        })

        let q = query(collection(fire, 'cuentas'), orderBy('fecha', 'desc'), limit(3))

        obtenerColeccionQuery(q).then((dox) => {
            if (dox.res) {
                setCuentas(dox.data)
            }
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#262626'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: !masSM ? 32 : 40, fontWeight: 700, lineHeight: 1.1}}
                >Bienvenido al Camino del Éxito Empresarial</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{fontSize: 16, fontWeight: 400, color: '#545454'}}
                >Emprender no se trata solo de dinero, sino de alcanzar las metas que realmente importan: libertad,
                    tiempo, propósito y realización personal.</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >

                    <Button
                        onClick={() => irUrl(URLUSUARIO + 'registro')}
                        variant={'outlined'}> Registro</Button>

                    <Button
                        onClick={() => irUrl(URLUSUARIO + 'ingreso')}
                        sx={{background: GRADIENTE}}> Ingresar</Button>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                >

                    <Grid container size={{xs: 4, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                        {cuentas.length > 0 &&
                            <AvatarGroup spacing={25}>
                                {cuentas.map((cuenta) => {
                                    return (
                                        <Avatar sx={{width: 50, height: 50}} alt={cuenta.nombre}
                                                src={cuenta.img ? cuenta.img : cuenta.nombre}/>
                                    )

                                })}

                            </AvatarGroup>
                        }

                    </Grid>

                    <Grid container size={{xs: 2, sm: 2, md: 3}} sx={{justifyContent: 'flex-start', pl: 1.5}}>
                        <Typography sx={{fontSize: !masSM ? 24 : 30, fontWeight: 600}}>{` +${numCuentas}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{fontSize: sCell ? 14 : 16, fontWeight: 400, color: '#545454', lineHeight: 1.1}}>Formandose
                            en este equipo</Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{fontSize: 14, fontWeight: 600, color: '#262626', fontFamily: 'Inter'}}
                >
                    Registrate ahora!
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography
                    sx={{fontSize: 14, fontWeight: 300, color: '#545454', fontFamily: "Inter"}}
                >
                    Alcanza ya mismo el éxito que mereces
                </Typography>
            </Grid>


        </Grid>
    )

}
export default PropuestaValor